import {useContextSelector} from 'use-context-selector'
import {ExplorerContext} from '../context/ExplorerContext'

export function useExplorerComposicao() {
  const composicao = useContextSelector(ExplorerContext, (data) => data['explorerComposicao'])
  const OnSetExplorerComposicao = useContextSelector(ExplorerContext, (data) => data['OnSetExplorerComposicao'])
  const onUpdateComposicao = useContextSelector(ExplorerContext, (data) => data['onUpdateComposicao'])
  return {composicao,OnSetExplorerComposicao,onUpdateComposicao}
}
